import { Injectable } from '@angular/core';
import { PropertyService } from '@app/_components/property/property.service';
import { AlertService } from './alert.service';
import { first, Observable, of, shareReplay } from 'rxjs';
import { ReportService } from '@app/_components/report';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '@app/_models';
import { environment } from '@environments/environment';
import { MessageService } from 'primeng/api';
import { SharedService } from './../_components/_shared/shared.service';

@Injectable({
	providedIn: 'root'
})
export class DataCacheService {
	constructor(
		private reportService: ReportService,
		private propertyService: PropertyService,
		private alertService: AlertService,
		private readonly http: HttpClient,
		private messageService: MessageService,
		private sharedService: SharedService) {

		this.loadDevelopments();
		this.loadShortTermRentals();
	}
	developmentSummaries = [];
	shortTermRentalSummaries = [];


	loadShortTermRentals() {
		this.reportService.propertySummaryList().pipe(first()).subscribe(

			res => {
				console.log('propertySummaryList SUCCESS: ' + JSON.stringify(res.data.propertySummaryList));
				this.shortTermRentalSummaries = res.data.propertySummaryList;
			},
			err => {
				console.log('reports LIST!: ' + JSON.stringify(err));
				this.messageService.add({ severity: 'error', summary: 'error.message', life: 3000 });
			},
			() => { }
		);
	}

	loadDevelopments() {
		this.reportService.developmentSummaryList()
			.subscribe(
				res => {
					console.log('developmentSummaryList SUCCESS: ' + JSON.stringify(res.data.developmentSummaryList));
					this.developmentSummaries = res.data.developmentSummaryList;
				},
				err => {
					console.log('developmentSummaryList FAIL: ' + JSON.stringify(err));
					this.messageService.add({ severity: 'error', summary: 'Get Developments List Failed', detail: 'We were unable to retrieve your developments: ' + err.message, sticky: false });
				},
				() => { });
	}

}